import { render } from "./MobileAppLink.vue?vue&type=template&id=6a87a02a&scoped=true&ts=true"
import script from "./MobileAppLink.vue?vue&type=script&lang=ts"
export * from "./MobileAppLink.vue?vue&type=script&lang=ts"

import "./MobileAppLink.vue?vue&type=style&index=0&id=6a87a02a&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/rontend-vue_version_release-euau/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a87a02a"]])

export default __exports__